import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import Spinner from '../ui/loader';
import { createOrder, iNewOrder } from '../api/ordersApi';
// import { ca } from 'date-fns/locale';

interface CreateOrderModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onOrderCreated?: () => void;
}

export function CreateOrderModal({ open, onOpenChange, onOrderCreated }: CreateOrderModalProps) {
  const [quantity, setQuantity] = useState<number>(1);
  const [carModel, setCarModel] = useState('');
  const [manufacturer, setManufacturer] = useState('');
  const [price, setPrice] = useState<number>(0);
  const [isLoading, setLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    setLoading(true);
    e.preventDefault();
    console.log({ quantity, carModel, price, manufacturer });
    // Reset form
    setCarModel('');
    setManufacturer('');
    setPrice(0);
    setQuantity(1);
    // onOpenChange(false);
    const newOrder: iNewOrder = {
      carModel: carModel as any,
      price: price,
      quantity: quantity,
      manufacturer: manufacturer as any
    };

    async function saveOrder() {
      try {
        console.log('Creating order:', newOrder);
        await createOrder(newOrder)
        setLoading(false);
        onOpenChange(false);
        if (onOrderCreated) {
          onOrderCreated();
        }
        console.log('Order created successfully');
      } catch (error) {
        console.error('Error creating order:', error);
        setLoading(false);

      }
    }

    saveOrder();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px] border border-primary">
        <DialogHeader>
          <DialogTitle>Create New Order</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          {/* <div className="space-y-2">
            <Label htmlFor="description">Description</Label>
            <Textarea
              id="description"
              placeholder="Enter order description..."
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="bg-background border-border resize-none"
              rows={3}
            />
          </div> */}

          <div className="space-y-2">
            <Label htmlFor="manufacturer">Manufacturer</Label>
            <Select value={manufacturer} onValueChange={setManufacturer}>
              <SelectTrigger className="bg-background border-border">
                <SelectValue placeholder="Select a manufacturer" />
              </SelectTrigger>
              <SelectContent className="bg-popover border-border">
                <SelectItem value="Volvo">Volvo</SelectItem>
                <SelectItem value="BMW">BMW</SelectItem>
                <SelectItem value="Audi">Audi</SelectItem>
                <SelectItem value="Toyota">Toyota</SelectItem>
                <SelectItem value="Ford">Ford</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="model">Model</Label>
            <Select value={carModel} onValueChange={setCarModel}>
              <SelectTrigger className="bg-background border-border">
                <SelectValue placeholder="Select a model" />
              </SelectTrigger>
              <SelectContent className="bg-popover border-border">
                <SelectItem value="XC70">XC70</SelectItem>
                <SelectItem value="V70">V70</SelectItem>
                <SelectItem value="XC90">XC90</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="price">Price</Label>
            <Input
              id="price"
              type="number"
              placeholder="Enter price..."
              value={price}
              onChange={(e) => setPrice(Number(e.target.value))}
              className="bg-background border-border"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="quantity">Quantity</Label>
            <Input
              id="quantity"
              type="number"
              placeholder="Enter quantity..."
              value={quantity}
              onChange={(e) => setQuantity(Number(e.target.value))}
              className="bg-background border-border"
            />
          </div>

          {/* <div className="space-y-2">
            <Label>Date</Label>
            <Popover>
              <PopoverTrigger asChild>
                <Button
                  variant="outline"
                  className={cn(
                    'w-full justify-start text-left font-normal bg-background border-border',
                    !date && 'text-muted-foreground'
                  )}
                >
                  <CalendarIcon className="mr-2 h-4 w-4" />
                  {date ? format(date, 'PPP') : <span>Pick a date</span>}
                </Button>
              </PopoverTrigger>
              <PopoverContent className="w-auto p-0 bg-popover border-border" align="start">
                <Calendar
                  mode="single"
                  selected={date}
                  onSelect={setDate}
                  initialFocus
                  className="p-3 pointer-events-auto"
                />
              </PopoverContent>
            </Popover>
          </div> */}

          <div className="flex justify-end gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
              className="border-border"
            >
              Cancel
            </Button>
            <Button type="submit" className="bg-primary text-primary-foreground hover:bg-primary/90">
              Create Order
            </Button>
          </div>
        </form>
        {isLoading && (Spinner({ loaderText: 'Creating order...' }))}
      </DialogContent>
    </Dialog>
  );
}
